import React, { useState, useEffect, useMemo } from 'react';
import { NotificationContainer } from 'react-notifications';
import EditarCadastarPagamento from './EditarCadastrar';
import { ContentHeader } from '../../components/ContentHeader';
import DuvidasButton from '../../components/DuvidasButton';
import { useAuth } from '../../hooks/auth';
import { Container, InputGroup, Table } from 'rsuite';
import api from '../../services/api';
import PlusIcon from '@rsuite/icons/Plus';
import SearchIcon from '@rsuite/icons/Search';
import { debounce } from '../../components/funcoes';
import { useCustomTheme } from '../../hooks/useCustomTheme';
import { CustomButton } from '../../components/CustomButton';
import { CustomInput } from '../../components/CustomInput';
import { CustomHeaderCell } from '../../components/CustomHeaderCell';
import { CustomCell } from '../../components/CustomCell';
import { FaMoneyBill } from 'react-icons/fa';

const { Column } = Table;

export default function Pagamento() {
  const { id_empresa } = useAuth();
  const [loading, setLoading] = useState(true);
  const [formasPagamento, setFormasPagamento] = useState('');
  const [bandeirasSelect, setBandeirasSelect] = useState([]);
  const [pagamento, setPagamento] = useState(null);
  const [modal, setModal] = useState(false);
  const { theme } = useCustomTheme();

  const [busca, setBusca] = useState('');

  const formasPagamentoMemo = useMemo(
    () =>
      busca.trim() === ''
        ? formasPagamento
        : formasPagamento.filter(({ Descricao = '' }) =>
          Descricao?.toLocaleLowerCase().includes(busca),
        ),
    [busca, formasPagamento],
  );

  const abrirDados = (pg) => {
    setPagamento(pg);
    setModal(true);
  };

  const cadastrar = () => {
    setPagamento(null);
    setModal(true);
  };

  const atualizar = async () => {
    await api
      .get('formas-pagamento/listar')
      .then((res) => {
        let pagamentosSelect = [];
        res.data?.forEach((obj) => {
          const novoObj = { value: obj.Id, label: `${obj.Descricao}` };
          pagamentosSelect.push(novoObj);
        });
        setBandeirasSelect(pagamentosSelect);
      })
      .finally(() => {
        setLoading(false);
      });
    await api
      .get(`forma-pagamento-empresa/listarGestor/${id_empresa}`)
      .then((res) => {
        if (res.data.length > 0) {
          setFormasPagamento(res.data);
        } else {
          setFormasPagamento([]);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const debounceSearch = debounce((valor = '') => {
    setBusca(valor.toLocaleLowerCase());
  }, 1000);

  useEffect(() => {
    atualizar();
  }, []);

  return (
    <Container
      style={{
        padding: '10px',
        height: 'calc(100vh - 60px)',
        backgroundColor: theme.colors.background,
      }}
    >
      <ContentHeader
        title="Pagamento"
        subtitle="Gerencie as formas de pagamento da sua empresa"
        icon={FaMoneyBill}
        secondComponent={
          <InputGroup inside style={{ width: '36vw', border: 'none' }}>
            <CustomInput onChange={debounceSearch} />
            <InputGroup.Addon>
              <SearchIcon color={theme.colors.textSecondary} />
            </InputGroup.Addon>
          </InputGroup>
        }
        thirdComponent={
          <>
            <DuvidasButton tela="pagamento" />
            <CustomButton appearance="primary" onClick={() => cadastrar()}>
              <PlusIcon style={{ marginRight: 6 }} /> Adicionar Pagamento
            </CustomButton>
          </>
        }
      />
      <Table
        height={window.innerHeight - 60 - 90}
        autoHeight
        bordered={true}
        loading={loading}
        data={formasPagamentoMemo}
        width={'100%'}
        style={{
          overflowY: 'auto',
          borderColor: theme.colors.backgroundSecondary,
          backgroundColor: theme.colors.backgroundSecondary,
          color: theme.colors.textSecondary,
        }}
        locale={{
          emptyMessage: 'Nenhuma forma de pagamento encontrada',
          loading: 'Carregando...',
        }}
      >
        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          align="center"
          fixed
        >
          <CustomHeaderCell>Código</CustomHeaderCell>
          <CustomCell dataKey="Id" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={2}
        >
          <CustomHeaderCell>Descrição</CustomHeaderCell>
          <CustomCell dataKey="Descricao" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          width={100}
          fixed="right"
        >
          <CustomHeaderCell>Ativo</CustomHeaderCell>

          <CustomCell dataKey="Fim">
            {(rowData) => (
              <span style={{ padding: 0 }}>
                {!!rowData.Ativo ? (
                  <CustomButton
                    appearance="primary"
                    style={{
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: 0,
                      width: 50,
                    }}
                    onClick={() => { }}
                  >
                    {' '}
                    Sim{' '}
                  </CustomButton>
                ) : (
                  <CustomButton
                    appearance="ghost"
                    style={{
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: 0,
                      width: 50,
                    }}
                    onClick={() => { }}
                  >
                    {' '}
                    Não{' '}
                  </CustomButton>
                )}
              </span>
            )}
          </CustomCell>
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          width={100}
          fixed="right"
        >
          <CustomHeaderCell>Opções</CustomHeaderCell>

          <CustomCell>
            {(rowData) => (
              <span>
                <CustomButton
                  color={theme.colors.warning}
                  appearance="ghost"
                  size="xs"
                  onClick={() => abrirDados(rowData)}
                >
                  {' '}
                  Editar{' '}
                </CustomButton>
              </span>
            )}
          </CustomCell>
        </Column>
      </Table>

      {modal && (
        <EditarCadastarPagamento
          modal={modal}
          close={() => setModal(false)}
          pagamento={pagamento}
          formasPagamento={formasPagamento}
          setFormasPagamento={setFormasPagamento}
          id_empresa={id_empresa}
          bandeirasSelect={bandeirasSelect}
        />
      )}
      <NotificationContainer />
    </Container>
  );
}
